export const support = [
  {
    id: 0,
    icon: 'icon-chat',
    text: 'سوالات متداول',
    route: 'questions',
  },
  {
    id: 1,
    icon: 'icon-phone-call',
    text: 'تماس با پشتیبانی',
    route: '09352593515',
  },
];
